import jquery from "jquery";
window.$ = window.jQuery = jquery;

const template = window.theme ? window.theme.template : null;
const pageType = window.theme ? window.theme.pageType : null;
const isCheckout = Shopify ? Shopify.Checkout : null;

console.log({
    template,
    pageType,
    isCheckout
});

// Modules + Base
import "./scripts/base/theme";
import "./scripts/modules/NavCartHover";
import "./scripts/modules/Cart";
import "./scripts/modules/CollectionValuePicker";
import "./scripts/modules/CartStickyHeader";
import "./scripts/modules/Discount";
import "./scripts/modules/DiscountGifts";
import "./scripts/modules/FixedHeader";
import "./scripts/modules/FlashSale";
import "./scripts/modules/infoBanner";
import "./scripts/modules/Minicart";
import "./scripts/modules/ProductStickyNav";
import "./scripts/modules/QuantitySelector";
import "./scripts/modules/ScrollAnimate";
import "./scripts/modules/Tabs";
import "./scripts/modules/Testimonials";
import "./scripts/modules/GiftCarousel";
import "./scripts/modules/WineryAwards";
import "./scripts/modules/Voucher";
import "./scripts/modules/FeaturedCollection";
import "./scripts/modules/ScrollUp";
import "./scripts/modules/searchCollections";
import "./scripts/modules/productOverlay";


if (pageType === 'collection') {
    import('./scripts/modules/CollectionFilterSearch').catch(error => {
        console.log('./scripts/modules/CollectionFilterSearch');
        console.warn(error);
    });
}

if (pageType === 'product' ||'collection' ) {
    import('./scripts/modules/Collapse');
}


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

